export const COLORS = {
    BLACK: '#000000',
    PINK: '#ff0050',
    BLUE: '#3066be',
    GOLD: '#ffd700',
    DARK_GRAY: '#121212',
    GRAY: '#808080', // Standard React gray
    GREEN: '#58b047',
    RED: '#ff0000'
};

// Individual color exports for more flexible importing
export const BLACK = COLORS.BLACK;
export const PINK = COLORS.PINK;
export const BLUE = COLORS.BLUE;
export const GOLD = COLORS.GOLD;
export const DARK_GRAY = COLORS.DARK_GRAY;
export const GRAY = COLORS.GRAY;
export const GREEN = COLORS.GREEN;
export const RED = COLORS.RED; 